import { useNavigate } from "react-router-dom";
import CphereHeaderLogo from "../components/CphereHeaderLogo";
import { useAdvertiser } from "../contexts/AdvertiserContext";
import { resolveVerticalDashboardConfig } from "../config/verticalDashboardConfig";
import "./CinemaAnalytics.css";
import "./AutoIntelligence.css";

const autoDashboardConfig = resolveVerticalDashboardConfig("automotive");

const MODULES = [
  {
    title: "Audience Intent",
    body:
      "Track signals that point to shopper intent, including engagement, qualified traffic, search behavior, and high-value audience response.",
  },
  {
    title: "Vehicle Interest",
    body:
      "Organize demand indicators around model interest, offer response, inventory-aligned attention, and creative themes that move prospects closer to consideration.",
  },
  {
    title: "Dealer / Geo Performance",
    body:
      "Read delivery and response by market so regional demand, dealer territories, and local media pressure can stay aligned.",
  },
  {
    title: "Lead Quality Signals",
    body:
      "Use site and conversion signals to separate broad traffic from shoppers showing stronger purchase or appointment intent.",
  },
  {
    title: "Creative & Offer Performance",
    body:
      "Evaluate which vehicle messages, incentives, formats, and placements are producing measurable response from in-market audiences.",
  },
  {
    title: "Recommended Optimizations",
    body:
      "Translate channel and audience signals into budget, creative, geo, and offer decisions for the next optimization cycle.",
  },
];

function AutoIntelligence() {
  const navigate = useNavigate();
  const { selectedAdvertiserName } = useAdvertiser() || {};

  return (
    <div className="reports-dashboard auto-intelligence-page">
      <div className="reports-content auto-intelligence-content">
        <CphereHeaderLogo
          alt="Powered by Logo"
          className="auto-analysis-poweredby-logo"
          onClick={() => navigate("/dashboard")}
          style={{ cursor: "pointer" }}
        />

        <section className="auto-intelligence-hero">
          <div className="auto-intelligence-hero-copy">
            <div className="auto-intelligence-kicker">
              {selectedAdvertiserName || "Selected Advertiser"}
            </div>
            <h1 className="auto-intelligence-title">Auto Intelligence</h1>
            <p className="auto-intelligence-copy">
              Automotive performance will be organized around shopper intent,
              vehicle interest, dealer-market response, lead quality, and
              creative or offer signals. The view is ready for automotive-specific
              modules as deeper data connections come online.
            </p>
          </div>

          <div className="auto-intelligence-hero-media" aria-hidden="true">
            <img
              src={autoDashboardConfig.tileImage}
              alt=""
              className="auto-intelligence-hero-image"
              draggable={false}
            />
          </div>
        </section>

        <section className="auto-intelligence-grid" aria-label="Auto Intelligence modules">
          {MODULES.map((module) => (
            <article className="auto-intelligence-card" key={module.title}>
              <h2>{module.title}</h2>
              <p>{module.body}</p>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}

export default AutoIntelligence;
